import React from 'react';
import Select from './Select'

const State = (props) => {
    const {field} = props;
    const values = [
        {label: "Select State"},
        {value: "Select State"},
    ]


return (<Select field={{...field, options: values}} />)
}

export default State;
